'use es6';
/**
 * IMPORTANT: At this time, this data can NOT BE immutable because the current layout editor will mutate data fed into it.
 *
 * Wrapper class of Revision data.
 * Intended for reflection and helper methods.
 */

export default class Revision {
  /**
   * @constructor
   */
  constructor(props) {
    if (props === Object(props)) {
      Object.keys(props).forEach(key => {
        this[key] = props[key];
      });
    }
  }

}